import { useSetAtom } from 'jotai'
import { useLoaderData, useNavigate } from 'react-router-dom'

import { useRequiredParams } from 'hooks/params.hook'
import type { ContainerType } from 'types/assembly/model'
import { OrderDetailSchema } from 'types/assembly/model'
import { ZOD_ERROR } from 'utils/constants'
import { palletProductsAtom } from '../Assemby.state'
import { useGoToPalletDetail } from '../pallet-detail/PalletDetail.navigator'

export const usePalletsList = () => {
  const navigate = useNavigate()
  const palletDetailPage = useGoToPalletDetail()
  const { transferId } = useRequiredParams('transferId')
  const rawOrder = useLoaderData()
  const setPalletProducts = useSetAtom(palletProductsAtom)

  const result = OrderDetailSchema.safeParse(rawOrder)
  if (!result.success) {
    throw Error(ZOD_ERROR)
  }

  const onGoBack = () => {
    navigate(-1)
  }

  const goToPalletDetail = (container: ContainerType) => {
    setPalletProducts(container.products)
    palletDetailPage.go(transferId, container.id)
  }

  return {
    pallets: result.data.containers,
    actions: { onGoBack, goToPalletDetail }
  }
}
